import React from "react";
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from '@components/custom/Search';
import {SelectionMode} from '@models/index';
import {SubscriptionStatus, SubscriptionStatusOptions} from "@models/subscription";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const UserSubscriptionsSearch: React.FC<SearchInputProps> = props => {
  const {search} = props;
  
  const inputs = [{
    name: "status",
    label: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
    type: SearchInputType.SELECT,
    options: SubscriptionStatusOptions,
    selectionType : SelectionMode.DEFAULT,
    size: 8,
  }];
  
  return(
    <Search
      inputs={inputs}
      search={search}
      hasClearButton={true}
      searchOnChange={false}/>
  )
};


export default UserSubscriptionsSearch;